import useAuthSettings from './useAuthSettings';

const useFeatureFlag = (name: string) => {
	const authSettings = useAuthSettings(['featureFlags']);

	return Boolean(authSettings?.featureFlags.includes(name));
};

export default useFeatureFlag;
